import { Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useRef, useState } from 'react';

// eslint-disable-next-line react/display-name
const TypographyTooltip = React.forwardRef(({ title, text, mixText, sx, maxLines = 1, ...props }, ref) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const typographyRef = useRef(null);

  useEffect(() => {
    const element = typographyRef.current;
    if (element) {
      // Kiểm tra xem nội dung có bị cắt không
      const isOverflowing = element.scrollHeight > element.offsetHeight || element.scrollWidth > element.offsetWidth;
      setIsTruncated(isOverflowing);
    }
  }, [text, mixText, maxLines]);

  return (
    <Tooltip title={isTruncated ? title || mixText || '' : ''} placement="top">
      <Typography
        ref={typographyRef}
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: maxLines,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          cursor: isTruncated ? 'pointer' : 'default',
          ...sx
        }}
        {...props}
      >
        {text || mixText || ''}
      </Typography>
    </Tooltip>
  );
});

export default TypographyTooltip;
